import BaseService from './_base.service';

export const rentalService = {
    page,
    edit,
    search,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/rental/page/"+page+"/"+size, callback, true)
}

function search(page,size,filter, callback) {
    return BaseService.post("/rental/page/"+page+"/"+size,filter, callback, true)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/rental/"+id, body, callback, true)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/rental/", body, callback, true)
}

function one(id,callback) {
    return BaseService.get("/rental/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/rental/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/rental/"+id+"/logic", callback);
}
